import React from "react";
import {
  RefreshCw, Scale, Link2, CheckCircle2,
} from "lucide-react";

export default function AdminTakedownsList({
  takedowns,
  loading,
  onRefresh,
  onAction,
}) {
  return (
    <div className="mt-8" data-testid="admin-takedowns-block">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <Scale size={18} />
          <h2 className="font-display font-black text-2xl tracking-tighter">
            Takedown Requests
          </h2>
          <span className="badge-neutral" data-testid="admin-takedowns-count">
            {takedowns.length} open
          </span>
        </div>
        <button
          onClick={onRefresh}
          className="text-xs uppercase tracking-widest font-semibold hover:text-red-600 flex items-center gap-2"
        >
          <RefreshCw size={12} className={loading ? "animate-spin" : ""} />
          Refresh
        </button>
      </div>
      {takedowns.length === 0 ? (
        <div
          className="border border-dashed border-zinc-300 p-8 text-center"
          data-testid="admin-takedowns-empty"
        >
          <CheckCircle2 size={24} className="mx-auto text-zinc-400" />
          <div className="label-eyebrow mt-2">No open takedowns</div>
        </div>
      ) : (
        <div className="space-y-3" data-testid="admin-takedowns-list">
          {takedowns.map((t) => (
            <TakedownRow key={t.id} t={t} onAction={onAction} />
          ))}
        </div>
      )}
    </div>
  );
}

function TakedownRow({ t, onAction }) {
  return (
    <div
      className="border border-zinc-900 bg-white p-4"
      data-testid={`admin-takedown-${t.id}`}
    >
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="label-eyebrow">
            {t.id} · {t.requester_role}
          </div>
          <div className="font-display font-black text-lg mt-0.5">
            {t.subject_name}
          </div>
          <div className="text-[11px] font-mono text-zinc-500 mt-0.5">
            {t.abuser_id}
          </div>
        </div>
        <div className="text-[11px] font-mono text-zinc-500">{t.status}</div>
      </div>
      <p className="text-sm mt-3 whitespace-pre-wrap">{t.reason}</p>
      {t.evidence_url && (
        <a
          href={t.evidence_url}
          target="_blank"
          rel="noreferrer"
          className="text-xs font-semibold inline-flex items-center gap-1 hover:text-red-600 mt-2"
        >
          <Link2 size={12} /> Evidence link
        </a>
      )}
      <div className="mt-3 flex flex-wrap gap-2">
        <button
          onClick={() => onAction(t.id, "remove")}
          className="px-3 py-1.5 text-[11px] uppercase tracking-widest font-bold bg-red-600 text-white hover:bg-red-700"
          data-testid={`takedown-remove-${t.id}`}
        >
          Remove Record
        </button>
        <button
          onClick={() => onAction(t.id, "under_review")}
          className="px-3 py-1.5 text-[11px] uppercase tracking-widest font-bold bg-zinc-900 text-white hover:bg-zinc-700"
          data-testid={`takedown-review-${t.id}`}
        >
          Mark Under Review
        </button>
        <button
          onClick={() => onAction(t.id, "dismiss")}
          className="px-3 py-1.5 text-[11px] uppercase tracking-widest font-bold border border-zinc-300 hover:border-zinc-900"
          data-testid={`takedown-dismiss-${t.id}`}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
